import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const AuthorizeUserRole = ({ allowedRoles, excludedRoles = [] }) => {
  const conUser = useSelector((state) => state?.conUser);
  console.log("... In AuthorizeUserRole ", conUser);
  console.log("... condiiton ", conUser?.roles?.includes("ADMIN"));

  if (!conUser?.roles) return <Navigate to="/signIn" replace />;

  return conUser?.roles.some((item) => allowedRoles.includes(item)) ? (
    <Outlet />
  ) : (
    <Navigate to="/signIn" replace />
  );
};

export default AuthorizeUserRole;
